module.exports = __webpack_public_path__ + "img/bttn_red_pin.2dedb0e0.png";